import nextId from "react-id-generator"
import collection4 from "../../images/collection4.png"
import collection3 from "../../images/collection3.png"

export const collections = [
    {
        id: nextId(),
        name: "dr martens",
        description: "new collection 2022",
        image: collection4
    },
    {
        id: nextId(),
        name: "dr martens",
        description: "new collection 2022",
        image: collection3
    },
]